import { Link } from "react-router-dom";

const CONTACT_EMAIL = "emergo.support@gmail.com";

const links = [
  { to: "/terms", label: "Terms of Service", id: "terms" },
  { to: "/privacy", label: "Privacy Policy", id: "privacy" },
  { to: "/cookies", label: "Cookie Notice", id: "cookie" },
  { to: "/support", label: "Support", id: "support" },
];

export const Footer = () => (
  <footer className="print:hidden border-t border-gray-200 py-8 text-sm text-gray-500" data-testid="site-footer">
    <div className="mx-auto max-w-[1100px] px-6 flex flex-wrap items-center justify-between gap-x-7 gap-y-4">
      <div data-testid="footer-copyright">
        Emergo © {new Date().getFullYear()} Laura Hockenhull ·{" "}
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="text-brand hover:underline">{CONTACT_EMAIL}</a>
      </div>
      <nav className="flex flex-wrap gap-x-[22px] gap-y-2" aria-label="Footer">
        {links.map((l) => (
          <Link key={l.id} to={l.to} data-testid={`footer-${l.id}-link`} className="font-semibold text-ink-2 hover:text-brand transition-colors">
            {l.label}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
);
